import type { AnyNode, TPlannedNode } from '../types'

export const isPlannedNode = (node?: AnyNode): boolean => {
  if ((node as TPlannedNode)?.id) return true

  return false
}
